import React from "react";
import { motion } from "framer-motion";
import "../loading/loading.scss"

const Loading = () => {
    return (
        <div className="loading">
            <motion.img
                src="/assets/logo.svg"
                alt="Logo"
                initial={{ scale: 0.9, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
            />
        </div>
    )
};

export default Loading